import React, { HTMLAttributes } from 'react';

const Guarantor = ({ className }: HTMLAttributes<HTMLElement>): JSX.Element => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0.54 0 16.92 40"
  >
    <path
      d="M13.399 24.62a6.264 6.264 0 0 0 1.88-4.477 6.291 6.291 0 0 0-6.283-6.284 6.29 6.29 0 0 0-6.284 6.284c0 1.751.72 3.337 1.88 4.477a4.604 4.604 0 0 0-4.057 4.566v9.895c0 .508.412.92.92.92h3.811a.92.92 0 0 0 0-1.84H2.375v-8.975a2.762 2.762 0 0 1 2.758-2.759h7.725a2.762 2.762 0 0 1 2.758 2.759v8.975H12.53a.92.92 0 0 0 0 1.84h3.811a.933.933 0 0 0 .098-.006.92.92 0 0 0 1.018-.914v-9.895a4.604 4.604 0 0 0-4.057-4.566Zm-4.403-.032a4.45 4.45 0 0 1-4.445-4.445A4.45 4.45 0 0 1 8.996 15.7a4.45 4.45 0 0 1 4.444 4.444 4.45 4.45 0 0 1-4.444 4.445Z"
      fill="#000"
    />
    <path
      d="M7.985 38.16h-.044a.92.92 0 0 0 0 1.84h.044a.92.92 0 0 0 0-1.84ZM10.307 4.845H7.683a.749.749 0 0 1 0-1.495h4.292a.92.92 0 0 0 0-1.84h-2.06V.92a.92.92 0 0 0-1.84 0v.59h-.392a2.59 2.59 0 0 0-2.587 2.587 2.59 2.59 0 0 0 2.587 2.588H10.307a.749.749 0 0 1 0 1.495H6.016a.92.92 0 0 0 0 1.84h2.06v.686a.92.92 0 0 0 1.839 0v-.686h.392a2.59 2.59 0 0 0 2.587-2.588 2.59 2.59 0 0 0-2.587-2.587Z"
      fill="#000"
    />
  </svg>
);

export default Guarantor;
